import { render, staticRenderFns } from "./SampleInvoice.vue?vue&type=template&id=0898bdc3&"
import script from "./SampleInvoice.vue?vue&type=script&lang=js&"
export * from "./SampleInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SampleInvoice.vue?vue&type=style&index=0&id=0898bdc3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports